import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  project: {
    display: 'flex',
    minWidth: '248px',
    maxWidth: '248px',
    height: '44px',
    padding: '12px 0 12px 12px',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    borderRadius: '8px',
    border: '1px solid rgba(30, 30, 30, 0.10)',
    cursor: 'pointer',
    '& .project-wrapper': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      '& .project-action': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
      },
    },
    '& .checkbox-wrapper': {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '& input': {
        display: 'none',
      },
      '& .custom-checkbox': {
        width: '16px',
        height: '16px',
        border: '1px solid rgba(30, 30, 30, 0.10)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'background-color 0.2s',
        position: 'relative',
        '&:after': {
          content: '""',
          fontSize: '16px',
          color: 'rgba(29, 143, 11, 0.70)',
          display: 'none',
          width: '16px',
          height: '16px',
          // eslint-disable-next-line max-len
          backgroundImage: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgOCA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC41IDIuNUwzIDVMNy41IDAuNSIgc3Ryb2tlPSIjMUQ4RjBCIiBzdHJva2Utb3BhY2l0eT0iMC43IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8L3N2Zz4K")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
        },
      },
      '& input.checked + .custom-checkbox': {
        border: '1px solid rgba(29, 143, 11, 0.70)',
        '&::after': {
          display: 'block',
        },
      },
    },
    '& .title': {
      fontSize: '14px',
      lineHeight: '16px',
    },
    '&:hover': {
      '& .checkbox-wrapper .custom-checkbox': {
        border: '1px solid rgba(108, 89, 230, 0.50)',
      },
    },
    '&.checked': {
      border: '1px solid rgba(29, 143, 11, 0.70)',
    },
  },
}));
